<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
      class="grey darken-4"
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">{{ deliveryOrderNo }} details</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-4 grey darken-4">
            <v-layout align-center pb-4>
              <v-flex text-xs-center >
                <div class="headline font-weight-medium text-center pl-3 pr-3 pt-3">{{ deliveryOrderNo }}</div>
                <div class="body-2 font-weight-bold text-center pl-3 pr-3">Order No: {{ salesOrderNo }}</div>
                <div class="body-2 pl-3 pr-3 grey--text">{{ createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                <v-btn
                  outline
                  small
                  class="mr-1"
                  :href="fullTrackingUrl"
                  v-if="trackingNo"
                  target="_blank"
                >Track</v-btn>
                <v-btn
                  outline
                  small
                  class="ml-1"
                  @click="emailDialog = true"
                >View Email</v-btn>
              </v-flex>
            </v-layout>

            <v-list three-line class="transparent">
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">perm_identity</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{ shippingTitle }} {{ shippingFirstName }} {{ shippingLastName }} - {{ shippingEmail }}
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">home</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{ shippingAddress }}
                  <v-list-tile-sub-title>{{ shippingCityName}}, {{ shippingPostCode }}, {{ shippingProvinceName }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">call</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{ shippingPhone }}
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">flight</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{ (customCourierName.length > 0 ? customCourierName : courierName + ' - ' + serviceName) }}
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">search</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Tracking No: {{ trackingNo }}
                  <v-btn
                    outline
                    small
                    class="mr-1"
                    :href="fullTrackingUrl"
                    v-if="trackingNo"
                    target="_blank"
                  >Track</v-btn>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-data-table
              :headers="headers"
              :items="items"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td align="center">
                  {{ props.item.salesOrderNo }}
                </td>
                <td>
                  <table>
                    <tr>
                      <td valign="top" class="item-name">
                        <img v-if="props.item.images.length > 0" :src="props.item.images[0].smallUrl" class="item-thumb">
                        <div v-else style="width:100%; height: 60px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                      </td>
                      <td class="item-name">
                        <strong>{{ props.item.name }}</strong>
                        <div v-for="optionItem in props.item.options" :key="optionItem.optionId">
                          {{ optionItem.optionName }}: {{ optionItem.valueCode }}
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
                <td class="text-xs-right">{{ props.item.qty }} {{ props.item.unit }}</td>
              </template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="emailDialog" max-width="1100px" style="overflow-x:auto; overflow-y:auto;">
        <v-card>
          <v-card-text>
            <iframe style="width:200%; height:400px;" :src="'/shipment/email/' + deliveryOrderNo"></iframe>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>

    </v-content>
  </div>
</template>

<style scoped>
  .media {
    height: 100%;
    margin: 0;
  }

  table.v-table tbody td:first-child {
    padding: 15px 15px;
  }

  .item-name {
    padding: 5px !important;
  }

  .item-thumb {
    width: 60px;
    height: auto;
  }
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import Loading from '@/components/Loading.vue'

export default {
  props: [
    'deliveryOrderNo'
  ],
  components: {
    SideDrawer,
    Loading
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      drawer: false,
      loading: false,
      headers: [
        {
          text: 'Sales Order No',
          align: 'center',
          sortable: false,
          class: ['subheading', 'font-weight-bold'],
          value: 'salesOrderNo'
        },
        {
          text: 'Item Name',
          align: 'center',
          sortable: false,
          class: ['subheading', 'font-weight-bold'],
          value: 'name'
        },
        { text: 'Qty',
          value: 'qty',
          align: 'right',
          class: ['subheading', 'font-weight-bold'],
          sortable: false
        }
      ],
      emailBody: '',
      emailDialog: false,
      salesOrderNo: '',
      createdDateTime: '',
      shippingTitle: '',
      shippingFirstName: '',
      shippingLastName: '',
      shippingAddress: '',
      shippingPostCode: '',
      shippingCityName: '',
      shippingProvinceName: '',
      shippingCountryName: '',
      shippingPhone: '',
      shippingCityId: '',
      shippingEmail: '',
      customCourierName: '',
      courierName: '',
      serviceName: '',
      trackingNo: '',
      trackingUrl: '',
      customTrackingUrl: '',
      fullTrackingUrl: '',
      items: []
    }
  },
  mounted () {
    this.openDrawerForDesktop()
    this.getDeliveryOrderDetails()
  },
  methods: {
    getDeliveryOrderDetails: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/delivery/' + _this.deliveryOrderNo)
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            this.salesOrderNo = resp.data.data.salesOrderNo
            this.createdDateTime = resp.data.data.createdDateTime
            this.createdDateTime = resp.data.data.createdDateTime
            this.shippingTitle = resp.data.data.shippingTitle
            this.shippingFirstName = resp.data.data.shippingFirstName
            this.shippingLastName = resp.data.data.shippingLastName
            this.shippingPhone = resp.data.data.shippingPhone
            this.shippingAddress = resp.data.data.shippingAddress
            this.shippingPostCode = resp.data.data.shippingPostCode
            this.shippingCityName = resp.data.data.shippingCityName
            this.shippingProvinceName = resp.data.data.shippingProvinceName
            this.shippingCountryName = resp.data.data.shippingCountryName
            this.shippingEmail = resp.data.data.shippingEmail
            this.status = resp.data.data.status
            this.customCourierName = resp.data.data.customCourierName
            this.courierName = resp.data.data.courierName
            this.serviceName = resp.data.data.serviceName
            this.trackingNo = resp.data.data.trackingNo
            this.trackingUrl = resp.data.data.trackingUrl
            this.customTrackingUrl = resp.data.data.customTrackingUrl
            this.fullTrackingUrl = resp.data.data.fullTrackingUrl
            this.items = resp.data.data.items
            this.emailBody = resp.data.data.emailBody
          } else {
            console.log('unable to load delivery order details: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    }
  }
}
</script>
